import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { SxHttpService } from './sxHttp.service';
import { AzureFile } from '../model/interfaces/azureFile.Interface';
import { ProductEmailAttribute, ProductEmailMappingResponse } from '../model/classes/productEmail.class';
import { MappingProductReportAttribute, MappingResponse as ProductReportMappingResponse } from '../model/classes/productReport.class';

export interface StandardFileContentModel {
    contentType: any;
    content: string;
  }
  
  
@Injectable()
export class AzureFileManagerService {
    private url = 'api/azurefilemanager';

    //Move away from here!
    constructor(private http: Http, private sxHttp: SxHttpService) { }

    //#region Output
    getOutputFiles(systemCode: String, outputCode: String): Observable<AzureFile[]> {
        const getUrl = this.url + `/GetAzureOutputFiles/${systemCode}/${outputCode}`;
        return this.sxHttp.get(getUrl).map(response => {
            return response.json().data as AzureFile[];
        });
    }

    uploadOutputFile(file: any): Promise<any> {
        return this.sxHttp.post(this.url + '/PostAzureFileOutputManager', file)
            .toPromise();
    }

    deleteOutputFile(systemCode: String, outputCode: String, file: AzureFile): Observable<Boolean> {
        const deleteUrl = this.url + `/DeleteOutputFile/${systemCode}/${outputCode}/${file.minFileName}/${file.extension}`;

        return this.sxHttp.delete(deleteUrl).map(response => {
            return response.json().data as Boolean;
        });
    }
    //#endregion

    //#region ProductReport
    getProductReportFiles(systemCode: String, businessCode: string, productCode: string, productReportCode: String): Observable<AzureFile[]> {
        const getUrl = this.url + `/GetAzureProductReportFiles/${systemCode}/${businessCode}/${productCode}/${productReportCode}`;
        return this.sxHttp.get(getUrl).map(response => {
            return response.json().data as AzureFile[];
        });
    }

    uploadProductReportFile(file: any): Promise<ProductReportMappingResponse> {
        return this.sxHttp.post(this.url + '/PostAzureFileProductReportManager', file)
            .toPromise()
            .then(response => response.json().data as ProductReportMappingResponse);
    }
    
  downloadTemplate(id: string): Observable<String> {
    const url = `${this.url}/GetAzureProductReportFiles/${id}`;
    return this.sxHttp
      .get(url)
      .map((response) => response.json().data as String);
  }

    deleteProductReportFile(
        systemCode: String, businessCode: string,
        productCode: string, productReprotCode: String, file: AzureFile): Observable<Boolean> {
        const deleteUrl =
            `${this.url}/DeleteProductReportFile/${systemCode}/${businessCode}/${productCode}/${productReprotCode}/${file.minFileName}/${file.extension}`;

        return this.sxHttp.delete(deleteUrl).map(response => {
            return response.json().data as Boolean;
        });
    }
    //#endregion

    //#region ProductEmail

    /**
     * Scan attributes from template
     * @param file template
     */
    scanProductEmailTemplate(file: any): Promise<ProductEmailMappingResponse> {
        const postUrl = `${this.url}/PostAzureFileProductEmail`;
        return this.sxHttp.post(postUrl, file)
            .map(response => {
                return  response.json().data as ProductEmailMappingResponse;
            })
            .toPromise();
    }
    //#endregion

}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/azureFileManager.service.ts